var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('InviteListDetailsHeader',_vm._b({key:_vm.listId},'InviteListDetailsHeader',{listId: _vm.listId, name: _vm.name, summary: _vm.summary},false)),_vm._v(" "),_c('InviteListDetailsTable',_vm._b({},'InviteListDetailsTable',{players: _vm.players, params: _vm.params, pagination: _vm.pagination, getPlayers: _vm.getPlayers},false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }